import * as request from 'services/request'

export const getUserRateLimits = async userId => {
  try {
    const response = await request.authorized(`/ratelimits/${userId}`)
    return response.json()
  } catch (error) {
    window.toastr.error(
      `Error getting rate limits for user ID ${userId} - ` + error
    )
  }
}

export const addUserRateLimits = async (userId, rateLimits) => {
  try {
    const response = await request.authorized(`/ratelimits/${userId}`, {
      method: 'POST',
      body: rateLimits
    })
    return response.json()
  } catch (error) {
    window.toastr.error(
      `Error creating rate limits for user ID ${userId} - ` + error
    )
  }
}

export const deleteUserRateLimits = async userId => {
  try {
    const response = await request.authorized(`/ratelimits/${userId}`, {
      method: 'DELETE'
    })
    return response.json()
  } catch (error) {
    window.toastr.error(
      `Error deleting rate limits for user ID ${userId} - ` + error
    )
  }
}

export default {
  getUserRateLimits,
  addUserRateLimits,
  deleteUserRateLimits
}



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/rate-limit-requests.js